// Formata para exibição (R$ 1.234,56)
export const formatCurrencyView = value => {
  const number = Number(value || 0);
  return number.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
  });
};

// Retorna valor formatado e classe CSS (negativo em vermelho)
export const formatCurrencyWithClass = value => {
  const number = Number(value || 0);
  const formatted = formatCurrencyView(number);
  return {
    value: formatted,
    className: number < 0 ? 'text-danger fw-bold' : '',
    isNegative: number < 0,
  };
};

// Função para formatar durante a digitação
export const formatCurrencyInput = inputValue => {
  // Se o valor já é um número (caso de inicialização), formata diretamente
  if (typeof inputValue === 'number') {
    return formatCurrencyView(inputValue);
  }

  // Se é string vazia ou null/undefined, retorna formatação de zero
  if (!inputValue || inputValue === '') {
    return formatCurrencyView(0);
  }

  // Verifica se é negativo (começa com - ou tem - em algum lugar)
  const isNegative = inputValue.includes('-');
  
  // Remove tudo exceto dígitos
  const digitsOnly = inputValue.replace(/\D/g, '');

  // Se só o sinal de menos foi digitado, preserva para que o usuário continue digitando
  if (isNegative && digitsOnly === '') {
    return '-';
  }

  // Converte para número (dividindo por 100 para considerar centavos)
  let numericValue = digitsOnly ? parseFloat(digitsOnly) / 100 : 0;
  
  // Aplica negativo se necessário
  if (isNegative) {
    numericValue = -numericValue;
  }
  
  // Retorna formatado ou zero se inválido
  return isNaN(numericValue)
    ? formatCurrencyView(0)
    : formatCurrencyView(numericValue);
};

// Converte valor formatado para número (R$ 1.234,56 → 1234.56 ou -R$ 1.234,56 → -1234.56)
export const unformatCurrency = formattedValue => {
  if (!formattedValue) return 0;

  // Verifica se é negativo antes de remover caracteres
  const isNegative = formattedValue.includes('-');

  // Remove símbolos (exceto o ponto de milhar) e converte vírgula decimal para ponto
  const numberString = formattedValue
    .replace(/[^\d,]/g, '') // Remove não-dígitos exceto vírgula
    .replace(/\./g, '') // Remove pontos de milhar
    .replace(',', '.'); // Converte vírgula decimal para ponto

  let numericValue = parseFloat(numberString || 0);
  
  // Aplica negativo se necessário
  if (isNegative && numericValue !== 0) {
    numericValue = -numericValue;
  }

  return numericValue;
};

// Alias para unformatCurrency para compatibilidade
export const parseCurrencyInput = unformatCurrency;

// Handler para inputs controlados
export const handleCurrencyChange = (e, setStateFunction) => {
  const inputValue = e.target.value;
  const formattedValue = formatCurrencyInput(inputValue);

  // Atualiza o estado com o valor formatado
  setStateFunction(prev => ({
    ...prev,
    valor: formattedValue,
  }));
};
